import styled from 'styled-components';

export const ItemWrapper = styled.div`
  display: flex;
  padding: 0.625rem;
  padding-bottom: 0;
  gap: 0.66em;
  align-items: center;
`;
